import { useEffect, useState } from 'react';
import { Card, CardBody } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { Col, Row } from '../ui/Layout.jsx';

let animation;
let wrapper;
let startTime;

const FallingTitles = (props) => {
    const { heading, subheading, groups = [], validate = [], action, speed = 20, fn } = props;

    // const _conditions = groups[1];

    const [conditions, setConditions] = useState([]);
    const [terms, setTerms] = useState([]);

    const [animationDuration, setAnimationDuration] = useState(0);
    const [animationPlay, setAnimationPlay] = useState(true);
    // const [round, setRound] = useState(0);
    const [falseChoice, setFalseChoice] = useState(null);
    const [falseChoiceCount, setFalseChoiceCount] = useState(0);
    const [truthChoice, setTruthChoice] = useState([]);
    const [pixelsPerSecond, setPixelsPerSecond] = useState(speed);

    const PIXELS_PER_SECOND = 20;
    const CYCLE_NUMBER = 10;

    useEffect(() => {
        console.log(falseChoiceCount);
    }, [falseChoiceCount]);

    useEffect(() => {
        let terms = [];
        groups[0].items.map((term, i) => {
            term.active = i === 0;
            term.done = false;
            terms.push(term);
        });
        setTerms(terms);

        let conds = [];
        groups[1].items.map((condition, i) => {
            condition.__classname = getRandomPositionFlex();
            conds.push(condition);
        });
        setConditions(conds);

        setTimeout(() => {
            animation = document.querySelector('.fallingtitles-animation');
            if (animation) setAnimationDuration(animation.offsetHeight / pixelsPerSecond);
            startTime = Date.now();
        }, 1500);
    }, []);

    useEffect(() => {
        let count = 0;
        let activeTerm = getActiveTerm();
        truthChoice.forEach((condition, i) => {
            count = diffTermAndCondition(activeTerm, condition) ? count + 1 : count;
        });

        let countValidateTerms = null;
        if (activeTerm) {
            countValidateTerms = validate.filter((item) => item.term.id === activeTerm.id).length;
        }

        console.log(count, countValidateTerms);
        if (count === countValidateTerms) {
            let _terms = [...terms];
            let index = [..._terms].findIndex((term) => term.id === activeTerm.id);
            console.log('index: ' + index);
            _terms[index] = {
                ..._terms[index],
                active: false,
                done: true,
            };
            if (_terms.length > index + 1) {
                _terms[index + 1] = {
                    ..._terms[index + 1],
                    active: true,
                };
            }
            // console.log(_terms)
            setTerms(_terms);
        }
    }, [truthChoice, terms]);

    useEffect(() => {
        let isDones = terms.map((term, i) => {
            return term.done;
        });

        if (isDones.length > 0 && isDones.every((item) => item === true)) {
            setAnimationPlay(false);
            fn.handleAction(action, { falseChoiceCount: falseChoiceCount, durationTime: (Date.now() - startTime) / 1000 });
        }
    }, [terms]);

    const getActiveTerm = () => {
        return terms.find((item) => item.active === true);
    };
    const getRandomPositionFlex = () => {
        const variants = ['justify-start', 'justify-center', 'justify-end'];
        return variants[Math.floor(Math.random() * variants.length)];
    };

    const diffTermAndCondition = (term, condition) => {
        if (!term || !condition || !validate) {
            return false;
        }

        console.log(term.id, condition.id);
        return validate.some((item) => {
            return item.term && item.condition && item.term.id === term.id && item.condition.id === condition.id;
        });
    };

    const setFalseChoiceCondition = (conditionToUpdate = null) => {
        setFalseChoice(conditionToUpdate);

        const updatedConditions = conditions.map((item) => {
            if (conditionToUpdate === null) {
                delete item.__choice;
                return {
                    ...item,
                    // __choice: null,
                };
            }
            if (item.id === conditionToUpdate.id) {
                return {
                    ...item,
                    __choice: false,
                };
            }
            return item;
        });
        setFalseChoice((prevState) => prevState + 1);
        setConditions(updatedConditions);
    };
    const setTruthChoiceCondition = (conditionToUpdate = null) => {
        const updatedConditions = conditions.map((item) => {
            if (conditionToUpdate === null) {
                delete item.__choice;
                return {
                    ...item,
                    // __choice: null,
                };
            }
            if (item.id === conditionToUpdate.id) {
                return {
                    ...item,
                    __choice: true,
                };
            }
            return item;
        });
        setTruthChoice((prevState) => [...prevState.filter((item) => item !== conditionToUpdate), conditionToUpdate]);
        setConditions(updatedConditions);
    };

    const handleClickCondition = (item) => {
        // pokud už je truth, nepokračuj dál
        if (truthChoice.find((truth) => truth.id === item.id)) {
            return;
        }

        let activeTerm = getActiveTerm();
        let isValid = diffTermAndCondition(activeTerm, item);

        if (isValid) {
            setTruthChoiceCondition(item);
        } else {
            setFalseChoice(item);
            setAnimationPlay(false);
            setFalseChoiceCount((prevState) => prevState + 1);

            // setFalseChoiceCondition(item);
            setTimeout(() => {
                setFalseChoice(null);
                setAnimationPlay(true);

                // setFalseChoiceCondition();
            }, 3000);
        }
    };

    if (conditions == null || conditions.length === 0) return '';
    if (terms == null || terms.length === 0) return '';
    return (
        <div className="component-fallingtitles">
            <HeadingOne heading={heading} />
            <h2 className="mt-12 text-center">{subheading}</h2>
            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardBody>
                            <div className={'fallingtitles-container' + (animationPlay === false ? ' --freeze' : '')}>
                                <div
                                    className="fallingtitles-animation"
                                    style={{
                                        display: animationDuration > 0 ? 'block' : 'hidden',
                                        animationDuration: animationDuration > 0 ? `${animationDuration}s` : '999999s',
                                        animationPlayState: animationPlay ? 'running' : 'paused',
                                    }}
                                >
                                    <div className="fallingtitles-wrapper">
                                        {Array.from(
                                            Array(CYCLE_NUMBER)
                                                .keys()
                                                .map((arrayKey) => {
                                                    return conditions.map((item, index) => (
                                                        <div key={index} className={'flex ' + item.__classname}>
                                                            <button
                                                                onClick={(e) => handleClickCondition(item)}
                                                                className={
                                                                    'fallingtitles-item' +
                                                                    (falseChoice?.id === item.id ? ' --false' : '') +
                                                                    (truthChoice.find((truth) => truth.id === item.id) ? ' --true' : '')
                                                                }
                                                            >
                                                                {item.label}
                                                            </button>
                                                        </div>
                                                    ));
                                                }),
                                        )}
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>

                    <div className="fallingtitles-terms">
                        <Row justify="center">
                            {terms?.map((term, index) => {
                                return (
                                    <Col key={index} base="auto">
                                        <button
                                            key={term.id}
                                            className={'fallingtitles-terms-button' + (term.active ? ' --active' : '') + (term.done ? ' --done' : '')}
                                        >
                                            {term.label}
                                        </button>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FallingTitles;
